import outcomeList from "./outcome-list/OutcomeList.vue";
import medicinesList from "../MedicineList";
import orderDetailList from "../orderDetailList";
import orderList from "../order-grid/OrderList.vue";

export default {
  components: {
    outcomeList,
    medicinesList,
    orderDetailList,
    orderList
  },
  data: () => ({
    showGrid: false,
    dialog: false,
    menu: false,
    patient: {
      id: "",
      documentType: "",
      document: "",
      fullname: "",
      address: "",
      cellPhoneNumber: "",
      phoneNumber: "",
      isPac: false,
      isPolicy: false
    },
    order: {
      id: "",
      status: "",
      number: "",
      deliveryAddress: "",
      orderType: {},
      deliveryDate: "",
      scheduleRange: "",
      cityId: "",
      stateItem: "",
      providerId: ""
    },
    showTextArea: false,
    clasification: [
      "medicamento incompleto",
      "medicamento incorrecto",
      "medicamento no entregado",
      "Cobro realizado no corresponde a la cuota",
      "Cobro realizado no corresponde al flete"
    ],
    notes: "",
    menuDelivery: false
  }),
  methods: {
    showArea() {
      showTextArea = true;
    },
    handleOrder(order) {
      this.showGrid = !this.showGrid;
    },
    closeOutcome() {
      this.dialog = false;
      this.showGrid = false;
    }
  }
};
